import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../../hooks/useUser';
import ItemOnlineReportCEO from './ItemOnlineReportCEO';
import ItemOnlineReportAdmin from './ItemOnlineReportAdmin';
import ItemOnlineReportManager from './ItemOnlineReportManager';
import { clearErrors } from './itemOnlineReportSlice';

const ItemOnlineReports = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearErrors());
    }, [dispatch]);

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <ItemOnlineReportCEO />;
    }
    if (roleLower === 'admin') {
        return <ItemOnlineReportAdmin />;
    }
    return <ItemOnlineReportManager />;
};

export default ItemOnlineReports;
